import { KafkaModel } from "../../models/kafka.model";
import { OrganizationModel } from "../../models/organization.model";


export const orgSelectedInOtherGroups = (org: OrganizationModel, kafkas: KafkaModel[], kafka?: KafkaModel) =>
    kafkas.filter(y => kafka?.GroupId === undefined || y.GroupId !== kafka?.GroupId).flatMap(z => z.Organizations.map(a => a.ID)).includes(org.ID)